// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_landing_ai_learning_description = /** @type {(inputs: {}) => string} */ () => {
	return `It also uses AI to provide engaging and personalised learning experiences. You can ask it to explain the meaning of a word or kanji, the meaning of a phrase, and a lot more. You can also engage in conversations with it, you can even personalise the AI to your preferences.`
};

const id_landing_ai_learning_description = /** @type {(inputs: {}) => string} */ () => {
	return `Aplikasi ini juga menggunakan AI untuk memberikan pengalaman belajar yang menarik dan personal. Anda dapat meminta aplikasi ini menjelaskan arti sebuah kata atau kanji, arti sebuah frasa, dan banyak lagi. Anda juga dapat terlibat dalam percakapan dengannya, Anda bahkan dapat mempersonalisasi AI sesuai dengan preferensi Anda.`
};

const ja_landing_ai_learning_description = /** @type {(inputs: {}) => string} */ () => {
	return `AIを活用し、魅力的でパーソナライズされた学習体験を提供します。単語や漢字の意味、フレーズの意味など、様々な質問をすることができます。AIと会話したり、好みに合わせてAIをカスタマイズしたりすることも可能です。`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "id" | "ja" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const landing_ai_learning_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.landing_ai_learning_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("landing_ai_learning_description", locale)
	if (locale === "en") return en_landing_ai_learning_description(inputs)
	if (locale === "id") return id_landing_ai_learning_description(inputs)
	return ja_landing_ai_learning_description(inputs)
};
export { landing_ai_learning_description as "landing.ai_learning_description" }